// ---- Horizontal menu scroller ----
const $menu = document.querySelector('.menu');
if ($menu) {
  const $items = $menu.querySelectorAll('.menu--item');
  const $images = $menu.querySelectorAll('.menu--item img');
  if ($items.length) {
    let menuWidth = $menu.clientWidth;
    let itemWidth = $items[0].clientWidth;
    let wrapWidth = $items.length * itemWidth;

    let scrollSpeed = 0;
    let oldScrollY = 0;
    let scrollY = 0;
    let y = 0;

    const lerp = (v0, v1, t) => v0 * (1 - t) + v1 * t;
    const dispose = (scroll) => {
      gsap.set($items, { x: (i) => i * itemWidth + scroll });
    };
    dispose(0);

    const handleMouseWheel = (e) => { scrollY -= e.deltaY * 0.9; };

    // Wheel (prevent only when we can scroll the rail)
    $menu.addEventListener('wheel', function (e) {
      const maxScroll = -(wrapWidth - menuWidth);
      const nextScroll = scrollY - e.deltaY * 0.9;
      if (nextScroll <= 0 && nextScroll >= maxScroll) {
        e.preventDefault();
        handleMouseWheel(e);
      }
    }, { passive: false });

    // Touch/drag
    let touchStart = 0, touchX = 0, isDragging = false;
    const handleTouchStart = (e) => {
      touchStart = e.clientX || e.touches[0].clientX;
      isDragging = true;
      $menu.classList.add('is-dragging');
    };
    const handleTouchMove = (e) => {
      if (!isDragging) return;
      touchX = e.clientX || e.touches[0].clientX;
      scrollY += (touchX - touchStart) * 2.5;
      touchStart = touchX;
    };
    const handleTouchEnd = () => { isDragging = false; $menu.classList.remove('is-dragging'); };

    $menu.addEventListener('touchstart', handleTouchStart);
    $menu.addEventListener('touchmove', handleTouchMove);
    $menu.addEventListener('touchend', handleTouchEnd);
    $menu.addEventListener('mousedown', handleTouchStart);
    $menu.addEventListener('mousemove', handleTouchMove);
    $menu.addEventListener('mouseleave', handleTouchEnd);
    $menu.addEventListener('mouseup', handleTouchEnd);
    $menu.addEventListener('selectstart', () => false);

    window.addEventListener('resize', () => {
      menuWidth = $menu.clientWidth;
      itemWidth = $items[0].clientWidth;
      wrapWidth = $items.length * itemWidth;
    });

    const render = () => {
      requestAnimationFrame(render);
      y = lerp(y, scrollY, 0.1);
      const maxScroll = -(wrapWidth - menuWidth);
      scrollY = Math.max(Math.min(scrollY, 0), maxScroll);
      dispose(y);
      scrollSpeed = y - oldScrollY;
      oldScrollY = y;
    };
    render();
  }
}

// ---- rm-media-text-modular vertical scroll slider (guarded) ----
if (window.gsap) { gsap.registerPlugin(ScrollTrigger); }

(function(){
  // stop desktop GSAP on mobile/tablet
  if (!window.matchMedia('(min-width: 992px)').matches) return;
  const scrollSection = document.querySelector('.scroll-section');
  const imagesContainer = document.querySelector('.images');

  // Only run if this module exists on the page
  if (!scrollSection || !imagesContainer) return;

  const images = imagesContainer.querySelectorAll('img');
  if (!images.length) return;

  const slideIndicator = document.getElementById('active-slide-index');
  const totalScrollHeight = images.length * window.innerHeight;

  gsap.to(imagesContainer, {
    y: () => `-${totalScrollHeight - window.innerHeight}px`,
    ease: 'none',
    scrollTrigger: {
      trigger: scrollSection,
      start: 'top top',
      end: () => `+=${totalScrollHeight}`,
      scrub: true,
      pin: true,
      anticipatePin: 1,
    }
  });

  const texts = document.querySelectorAll('.left-column .text-item');
  function showText(index) {
    texts.forEach((t, i) => t.classList.toggle('active', i === index));
    if (slideIndicator) slideIndicator.textContent = String(index + 1).padStart(2, '0');
  }

  images.forEach((img, i) => {
    ScrollTrigger.create({
      trigger: img,
      start: 'center center',
      end: 'bottom center',
      onEnter: () => showText(i),
      onEnterBack: () => showText(i),
    });
  });
})();

/* ------------------------------
   MOBILE SLIDER DOTS PATCH
   ------------------------------ */
document.addEventListener("DOMContentLoaded", function () {
  // find all scroll sections that have a mobile track
  const sections = document.querySelectorAll(".scroll-section");
  if (!sections.length) return;

  sections.forEach((section) => {
    const track  = section.querySelector(".rm-mobile-track");
    const slides = track ? Array.from(track.querySelectorAll(".rm-m-slide")) : [];
    const dots   = Array.from(section.querySelectorAll(".rm-m-dot"));

    if (!track || !slides.length || !dots.length) return;

    // width of one slide
    function getSlideWidth() {
      return slides[0].getBoundingClientRect().width;
    }

    // update active dot based on scroll position
    function updateDots() {
      const slideWidth = getSlideWidth() || 1;
      let idx = Math.round(track.scrollLeft / slideWidth);

      // clamp index
      if (idx < 0) idx = 0;
      if (idx > slides.length - 1) idx = slides.length - 1;

      dots.forEach((dot, i) => {
        dot.classList.toggle("is-active", i === idx);
      });
    }

    // clicking a dot scrolls to the slide
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        const slideWidth = getSlideWidth();
        track.scrollTo({
          left: i * slideWidth,
          behavior: "smooth",
        });
      });
    });

    // listen for swipe scroll
    track.addEventListener("scroll", () => {
      window.requestAnimationFrame(updateDots);
    });

    // on resize recalc dot position
    window.addEventListener("resize", updateDots);

    // initialize
    updateDots();
  });
});
